import { useEffect, useState } from 'react';
import { FlexGrid, Typography, useThemeProvider, Card, Skeleton, Separator, Button, useDialog } from '@albo-ui/core'
import { CustomerFeaturesProps } from './types';
import { useFraudTable } from './hooks/useFraudTable';
import { useFraudAdmin } from './hooks/useFraudAdmin';
import DataTable from 'react-data-table-component';
import { customStyles2 } from '../../../util/TableStyles'
import { noDataComponent } from '../../../util/DataObject'
import { paginationComponentOptions } from '../../../util/i18n-es';
import SavingsIcon from '@mui/icons-material/Savings';
import { Box, IconButton, MenuItem, Tab, Tabs, TextField } from '@mui/material';
import { Search } from '@mui/icons-material';
import { UpdateStatusDialog } from '../../modals/fraud-admin/UpdateStatusDialog';
import { AddFraudDialog } from '../../modals/fraud-admin/AddFraudDialog';
import { ConfigFraudDialog } from '../../modals/fraud-admin/ConfigFraudDialog';
import useExpandableRows from './hooks/useExpandableRows';
import SelectDialog from '../../modals/select';

export const FraudList = ({ changeAlert, changeLoader, sectionData, catalogs }: CustomerFeaturesProps) => {
    const [ rowUpdate, setRowUpdate ] = useState({});
    const [ errorAdd, setErrorAdd ] = useState(false)
    const [ typeCreate, setTypeCreate ] = useState('')
    const [ updateData, setUpdateData ] = useState(null)
    const [ origin, setOrigin ] = useState('')
    const { theme } = useThemeProvider();
    const updateDialog = useDialog()
    const addDialog = useDialog()
    const createDialog = useDialog()
    const selectDialog = useDialog()

    const onOpenUpdateState = (row) => {
        setRowUpdate(row)
        updateDialog.openDialog()
    }
    const handleGet = () => {
        getData(page, perPage, filters, tabActive)
    }
    const handleGetConfig = (tab) => {
        selectService(tab)
    }
    const onAddRegister = async () => {addDialog.openDialog()}
    const onCloseDialogAdd = () => {
        setUpdateData(null)
        setRowUpdate(false)
        addDialog.onClose()
    }
    
    const onCreateConfig = async () => {createDialog.openDialog()}
    const onCloseDialogCreate = () => {
        setErrorAdd(false)
        setUpdateData(null)
        createDialog.onClose() 
    }

    const onOpenSelect = async () => {selectDialog.openDialog()}
    const onCloseSelect = () => {selectDialog.onClose()}
    const redirectCreateDialog = (item) => {
        selectDialog.onClose()
        setTypeCreate(item)
        return item === 'configAcc' ? onCreateConfig() : onAddRegister()
    }
    const redirectUpdateDialog = (tab, row, origin) => {
        setTypeCreate(tab)
        setUpdateData(row)
        origin ? setOrigin(origin) : setOrigin('')
        return tab === 'configAcc' ? onCreateConfig() : onAddRegister()
    }

    const { loading: loadingUpdate, title, updateStatus, addRegister, createConfig, updateConfig } = useFraudAdmin(changeAlert, handleGet, handleGetConfig, onCloseDialogAdd, onAddRegister, setErrorAdd, onCloseDialogCreate, onCreateConfig, redirectUpdateDialog, origin)
    const { columns, data, dataConfig, loading: loadingTable, page, perPage, totalRows, filters, channel, operation, tabs, tabActive, fraudTypeList, getData, selectService, changeTab, fraudFilter, changeValueSearch, saveData, handlePageChange, handlePerRowsChange, DialogConfirm } = useFraudTable(changeAlert, onOpenUpdateState, redirectUpdateDialog)

    const onUpdateStatus = async (data: any) => {
        updateDialog.onClose()
        updateStatus(data)
    }
    const onCloseDialogUpdate = () => {
        updateDialog.onClose()
    }
    
    function findActiveTab(item) { 
        return item.name === tabActive;
    }
    
    useEffect(() => {
       saveData(sectionData)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    useEffect(() => {
        changeLoader(loadingUpdate)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingUpdate])
    useEffect(() => {
        changeLoader(loadingTable)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable])
    
    return (
        <Card padding={4} flexDirection='column' fullWidth fullHeight alignItems='stretch' justifyContent='space-between' style={{ borderColor: theme.colors.manatee }}> 
            <FlexGrid container fullWidth justify='space-between'>
                <FlexGrid item>
                    <Typography variant='h2' style={{display: 'inline-flex', alignItems: 'center', fontSize: '1.2rem'}}>
                        <SavingsIcon sx={{ marginRight: 1 }}/> Administrador de Fraude
					</Typography>
                </FlexGrid>
                {tabActive !== 'reboot' && 
                    <FlexGrid item>
                        <FlexGrid container spacing={2}>
                            <Button onClick={onOpenSelect} buttonType='secondary' size='normal' style={{width: 110}}>Agregar</Button>
                        </FlexGrid>
                    </FlexGrid>
                }
            </FlexGrid>

            <FlexGrid container spacing={2} style={{width: 520, paddingTop: 15}}>
                <TextField select value={filters['channel'] || -1} onChange={changeValueSearch.bind(this, 'channel')} defaultValue={-1} size='small' fullWidth color='secondary'>
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    <MenuItem value={''} >Todos</MenuItem>
                    {channel.map((item) => (
                        <MenuItem key={`channel-${item.key}`} value={item.value}>{item.label}</MenuItem>
                    ))}
                </TextField>
                <TextField select value={filters['operation'] || -1} onChange={changeValueSearch.bind(this, 'operation')} defaultValue={-1} size='small' fullWidth color='secondary'>
                    <MenuItem value={-1} disabled>Seleccione</MenuItem>
                    <MenuItem value={''} >Todos</MenuItem>
                    {operation.map((item) => (
                        <MenuItem key={`operation-${item.key}`} value={item.value}>{item.label}</MenuItem>
                    ))}
                </TextField>
                <IconButton onClick={fraudFilter.bind(this)} sx={{padding: '0 !important'}}><Search sx={{padding: '7px', borderRadius: 2, boxSizing: 'content-box', color: 'white', backgroundColor: '#8bc179' }}/></IconButton>
            </FlexGrid>
            <FlexGrid container spacing={2} style={{width: 520, paddingTop: 15, paddingBottom: 30}}>
                <TextField
                    label={'UUID'} value={filters['uuid'] || ''} color='secondary' size='small' fullWidth 
                    onChange={changeValueSearch.bind(this, 'uuid')}                    
                />
            </FlexGrid>

            <Box sx={{ borderBottom: 1, borderColor: 'divider' }} mb={2} >
              <Tabs value={tabs.findIndex(findActiveTab)} indicatorColor='secondary' textColor='secondary' >
                {tabs.map((item, index) => {
                  return <Tab key={index} label={item.title} onClick={changeTab.bind(this, item.name)} sx={{fontWeight: 'bold', textTransform: 'none',  fontFamily: 'Muli,sans-serif', fontSize: 16, paddingRight: '30px !important'}}/>
                })}
              </Tabs>
            </Box>

            { data?.length === 0 && <Separator orientation='horizontal' style={{minHeight: 4, maxHeight: 4}} />}
            <FlexGrid container style={{margin: '25px 0' }} direction='column'>
                {
                    loadingTable ?
                        <Skeleton width='100%' height='100px' />
                        :
                        <DataTable
                            columns={columns}
                            data={data}
                            customStyles={customStyles2}
                            noDataComponent={noDataComponent}
                            progressPending={loadingTable}
                            pagination
                            paginationServer
                            paginationDefaultPage={page}
                            paginationPerPage={perPage}
                            paginationTotalRows={totalRows}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            paginationComponentOptions={paginationComponentOptions}
                            expandableRows={tabActive === 'accumulator' || tabActive === 'configAcc' ? true : false}
                            expandOnRowClicked={false}
                            expandableRowsComponent={useExpandableRows.bind(this, dataConfig, catalogs)}
                        />
                }
            </FlexGrid>
            <UpdateStatusDialog 
                title={title} 
                open={updateDialog.open} 
                onClose={onCloseDialogUpdate} 
                onConfirm={onUpdateStatus.bind(this)}  
                row={rowUpdate}
                type={tabActive}
            />
            <DialogConfirm />
            <AddFraudDialog 
                title={updateData ? 'Editar registro' : 'Crear registro'}
                open={addDialog.open}
                onClose={onCloseDialogAdd}
                onConfirm={addRegister.bind(this)}
                operation={operation}
                channel={channel}
                type={fraudTypeList}
                error={errorAdd}
                tabActive={typeCreate}
                update={updateData || null}
            />
            <ConfigFraudDialog 
                title={updateData ? 'Editar registro' : 'Crear registro'}
                open={createDialog.open}
                onClose={onCloseDialogCreate}
                onConfirm={updateData ? updateConfig.bind(this) : createConfig.bind(this)}
                operation={operation}
                channel={channel}
                error={errorAdd}
                catalogs={catalogs}
                update={updateData || null}
                origin={origin}
            />
            <SelectDialog
                title={'Seleccione tipo de registro'}
                open={selectDialog.open}
                onClose={onCloseSelect}
                onConfirm={redirectCreateDialog.bind(this)}
                menu={tabs}
            />
        </Card>
    )
}

